// Hindi is Devanagari (owner decision 2026-10-28); tests/hindi-register.test.ts guards it.
export const CHOGHADIYA_COPY = {
  en: {
    kicker: "Aaj Ka Choghadiya",
    heading: "Today's Choghadiya",
    loadingLabel: "Loading today's Choghadiya",
    loadingBody: "Calculating day and night Choghadiya for your city",
    fetchError: "Failed to load Choghadiya",
    retry: "Try Again",
    trust: ["Accurate Vedic calculations", "Updated Daily", "100% Free"],
    rating: "Was this Choghadiya accurate for your city?",
  },
  hi: {
    kicker: "आज का चौघड़िया",
    heading: "आज का चौघड़िया",
    loadingLabel: "आज का चौघड़िया लोड हो रहा है",
    loadingBody: "आपके शहर के दिन और रात के चौघड़िया की गणना हो रही है",
    fetchError: "चौघड़िया लोड नहीं हो सका",
    retry: "दोबारा कोशिश करें",
    trust: ["सटीक वैदिक गणना", "रोज़ अपडेट", "100% मुफ़्त"],
    rating: "क्या यह चौघड़िया आपके शहर के लिए सही था?",
  },
} as const;
